module.exports = __webpack_public_path__ + "static/media/thumbs-up.27febb01.svg";